import { useDashboardStyles } from "./styles";
import DashboardLink, { DashboardLinkProps } from "./DashboardLink";

type DashboardGroupProps = {
    title: string;
    subtitle?: string;
    items: DashboardLinkProps[];
    isDisplayed?: boolean;
};

const DashboardGroup = (props: DashboardGroupProps) => {
    const { title, items, isDisplayed, subtitle } = props;
    const dashboardStyles = useDashboardStyles();
    return (
        <>
            {(isDisplayed || isDisplayed === undefined) && (
                <div className="mb-5">
                    <div className="card-body">
                        <h3
                            style={dashboardStyles.tileTitle}
                            className="border-bottom mb-3 pb-2"
                        >
                            {title}
                        </h3>
                        {subtitle && (
                            <p style={dashboardStyles.sectionSubtitle} className="mb-2">
                                {subtitle}
                            </p>
                        )}
                        <div className="container-fluid">
                            <div className="row gx-5">
                                {items.filter(function (x) { return x.isDisplayed || x.isDisplayed === undefined }).map((item: DashboardLinkProps, index: number) => (
                                            <div className="col-12  col-xl-6  px-4 py-2" key={index}>
                                                <div className="border rounded p-3 bg-light">
                                                    <DashboardLink
                                                        title={item.title}
                                                        subtitle={item.subtitle}
                                                        href={item.href}
                                                        isDisplayed={item.isDisplayed}
                                                    />
                                                </div>
                                            </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
DashboardGroup.defaultProps = {
    handleClick: { undefined },
};
export type { DashboardGroupProps };
export default DashboardGroup;
